// extracted by mini-css-extract-plugin
module.exports = {"list":"experiments_list__f3cCD","divider":"experiments_divider__LV59l","section":"experiments_section__giLGb"};